import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
  pagingPatientTypeService,
  savePatientTypeService,
  deletePatientTypeService,
  getPatientTypeServiceById,
  getAllPatientTypeService,
  syncPatientTypeService,
} from "app/services/PatientTypeServiceService";

import { ConceptType } from "app/common/Model/ConceptType";
import { toast } from "react-toastify";
import {
  downloadTemplatePatientTypeService,
  importExcelPatientTypeService,
} from "app/services/ImportExcelService";

export default class PatientTypeServiceStore {
  listAllPatientTypeService = [];
  searchPatientTypeService = new SearchObject();
  pagePatientTypeService = null;
  selectedPatientTypeService = null;
  openFormCreateOrEdit = false;
  openConfirmDeletePatientTypeService = false;

  constructor() {
    makeAutoObservable(this);
  }

  pagingPatientTypeService = () => {
    pagingPatientTypeService(this.searchPatientTypeService).then(({ data }) => {
      this.pagePatientTypeService = data;
    });
  };

  selectPatientType = () => {
    this.searchPatientTypeService = new SearchObject({ type: 1 });
    this.pagingPatientTypeService();
  };

  selectPriceCategory = () => {
    this.searchPatientTypeService = new SearchObject({ type: 2 });
    this.pagingPatientTypeService();
  };

  handleChangeFormSearch = (searchPatientTypeService) => {
    this.searchPatientTypeService = {
      ...this.searchPatientTypeService,
      ...searchPatientTypeService,
    };
    this.pagingPatientTypeService();
  };

  handleOpenFormCreateOrEdit = (patientTypeServiceId) => {
    if (Boolean(patientTypeServiceId)) {
      getPatientTypeServiceById(patientTypeServiceId)
        .then(({ data }) => {
          this.selectedPatientTypeService = data;
          this.openFormCreateOrEdit = true;
        })
        .catch(function (error) {
          toast.error("Lấy dữ liệu có lỗi");
        });
    } else {
      this.selectedPatientTypeService = new ConceptType();
      this.openFormCreateOrEdit = true;
    }
  };

  savePatientTypeService = async (patientTypeService, { setSubmitting }) => {
    return await savePatientTypeService(patientTypeService)
      .then(() => {
        this.selectedPatientTypeService = null;
        toast.success("Lưu thành công");
        this.pagingPatientTypeService();
        this.handleClosePopup();
      })
      .catch(function (error) {
        console.error(error);
        toast.error("Có lỗi xảy ra");
      })
      .finally(function () {
        setSubmitting(false);
      });
  };

  updatePatientTypeService = async (patientTypeService, { setSubmitting }) => {
    return await savePatientTypeService(patientTypeService)
      .then(() => {
        this.selectedPatientTypeService = null;
        toast.success("Cập nhật thành công");
        this.pagingPatientTypeService();
        this.handleClosePopup();
      })
      .catch(function (error) {
        console.error(error);
        toast.error("Có lỗi xảy ra");
      })
      .finally(function () {
        setSubmitting(false);
      });
  };

  handleDeletePatientTypeService = (patientTypeService) => {
    this.selectedPatientTypeService = patientTypeService;
    this.openConfirmDeletePatientTypeService = true;
  };

  handleConfirmDeletePatientTypeService = () =>
    deletePatientTypeService(this.selectedPatientTypeService?.id)
      .then(() => {
        if (
          this.searchPatientTypeService?.pageIndex > 1 &&
          this.pagePatientTypeService?.content?.length === 1
        ) {
          this.searchPatientTypeService.pageIndex -= 1;
        }
        toast.success("Lưu thành công");
        this.pagingPatientTypeService();
        this.handleClosePopup();
      })
      .catch(function (error) {
        toast.error("Có lỗi xảy ra");
      });

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeletePatientTypeService = false;
  };

  getAllPatientTypeService = async () => {
    let { data } = await getAllPatientTypeService();
    this.listAllPatientTypeService = data || [];
  };

  handleImportPatientTypeService = (file) => {
    importExcelPatientTypeService(file)
      .then(({ data }) => {
        toast.success("Tải file thành công!");
        this.pagingPatientTypeService();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleDownloadExcelTemplate = async () => {
    try {
      const response = await downloadTemplatePatientTypeService();

      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "DOI_TUONG_KH.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  hanleSyncPatientTypeService = () => {
    syncPatientTypeService()
      .then(({ data }) => {
        toast.success("Đồng bộ thành công");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Đồng bộ dữ liệu có lỗi");
      });
  };

  resetStore = () => {
    this.searchPatientTypeService = new SearchObject();
    this.pagePatientTypeService = null;
    this.selectedPatientTypeService = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeletePatientTypeService = false;
  };
}
